import script from "./AdminTourTable.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminTourTable.vue?vue&type=script&setup=true&lang=js"

import "./AdminTourTable.vue?vue&type=style&index=0&id=46b7f9ac&lang=css"

const __exports__ = script;

export default __exports__